import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

function scrollToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

function scrollToHash(hash: string) {
  const id = hash.replace(/^#/, "");
  if (!id) {
    scrollToTop();
    return;
  }

  const scroll = () => {
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: "auto", block: "start" });
    } else {
      scrollToTop();
    }
  };

  requestAnimationFrame(() => {
    requestAnimationFrame(scroll);
  });
}

/** Resets scroll position on route changes (SPA default is to preserve scroll). */
export const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    if (!hash) {
      scrollToTop();
    }
  }, [pathname, search, hash]);

  useEffect(() => {
    if (hash) {
      scrollToHash(hash);
    }
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
